import React from 'react';
import { VippedPage } from '../../components/Views/VippedPage';
import { getSeoData, getLocaleFromBrowser } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import { getFilterVariantsForVipPage } from '../../api/queries';
import { getStaticData } from '../../utils/helpers/getStaticData';
import {
  getVippedBreadcrumbs,
  parseVippedFiltersFromQuery
} from '../../utils/helpers/vipped';
import { getI18nForLang } from '../../utils/helpers/getI18nForLang';
import CONFIG from '../../config';

const Vipped = props => <VippedPage {...props} />;

Vipped.getInitialProps = async ({ apolloClient, asPath, req, query, lng }) => {
  const adaptFilter = parseVippedFiltersFromQuery(query);
  const isBaseVipPage = !Object.keys(adaptFilter).length;
  const currentLang = lng || CONFIG.defaultLocale;

  try {
    const [filterVariantsForVipPage, seoData, staticData] = await Promise.all([
      apolloClient.query({ query: getFilterVariantsForVipPage }),
      getSeoData(apolloClient, asPath, req),
      getStaticData(apolloClient)
    ]);

    const { breadcrumbs, currAdaptFilter } = getVippedBreadcrumbs(
      filterVariantsForVipPage?.data,
      adaptFilter
    );

    return {
      seoData,
      breadcrumbs,
      isBaseVipPage,
      adaptFilter: currAdaptFilter,
      currentLang,
      ...staticData
    };
  } catch (error) {
    console.error('Error fetching data:', error);

    return {
      isBaseVipPage,
      adaptFilter,
      breadcrumbs: [],
      seoData: {},
      keywords: [],
      categories: [],
      citiesUnPopularList: [],
      regions: {},
      currentLang,
      ssrError: true
    };
  }
};

Vipped.getLayout = (page, pageProps) => {
  let currentLang = pageProps?.currentLang;
  if (!currentLang && typeof window !== 'undefined') {
    currentLang = getLocaleFromBrowser();
  }
  currentLang = currentLang || CONFIG.defaultLocale;
  const i18n = getI18nForLang(currentLang);

  return (
    <Layout
      noBorder
      isShowBackButton
      isBottomNavigation
      hideMobileHeader
      headerTitle={i18n.t('sections.vipped.title')}
    >
      {page}
    </Layout>
  );
};

export default Vipped;
